import React from "react";
import UserEvent from "../../core/UserEvent";
import lang from "../../core/lang";
import PropTypes from 'prop-types';
import {TextField, useTheme} from "@material-ui/core";
import numeral from "../../core/numeral";
import {makeStyles} from "@material-ui/core/styles";
import i18n from "../../core/i18n";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
    root: {
        '& input': {
            color: props => props.color
        }
    }
}));


function NumberField(props) {
    const {min, max, step, readOnly, className, disabled} = props;
    const theme = useTheme();
    const style = {...props.style};
    const handleChange = event => {
        const value = numeral.parse(event.target.value);
        props.onChange && props.onChange(new UserEvent({value}, event));
    }

    const value = lang.isNullOrUndefined(props.value) ? '' : props.value;

    const options = lang.omit(props, 'value', 'disabled', 'readOnly', 'min', 'max', 'step', 'nullable', 'color');

    let ariaLabel;
    if(props["aria-label"]) {
        ariaLabel = i18n.translate(props["aria-label"]);
    } else {
        ariaLabel = i18n.translate(lang.isString(props.label) ? props.label : '');
    }
    const inputProps = {
        'aria-label': ariaLabel,
        min: min,
        max: max,
        step: step,
        readOnly
    }

    const calcColor = (theme, color) => {
        const tokens = color.split('.');
        let themeColor = theme.palette[tokens[0]];
        for(let i = 1; i<tokens.length; i++) {
            if(themeColor[tokens[i]]) {
                themeColor = themeColor[tokens[i]];
            } else {
                break;
            }
        }
        return themeColor || color;
    };
    const color = lang.isFunction(props.color) ? props.color(value) : (props.color || theme.palette.text.primary);
    const effectiveColor = color ? calcColor(theme, color) : undefined;

    const classes = useStyles({color: effectiveColor});
    if(readOnly) {
        style.pointerEvents = '';
    }

    return (
        <TextField  {...options} aria-label={ariaLabel} classes={classes} className={clsx('appfuse-NumberField', className)} style={style}
                    type="number" value={value} onChange={handleChange} inputProps={inputProps} disabled={disabled} />
    )
}

NumberField.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    value: PropTypes.number,
    onChange: PropTypes.func,
    name: PropTypes.string,
    variant: PropTypes.oneOf(['standard', 'outlined', 'filled']),
    size: PropTypes.oneOf(['large', 'medium', 'small']),
    fullWidth: PropTypes.bool,
    readOnly: PropTypes.bool,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    min: PropTypes.number,
    max: PropTypes.number,
    step: PropTypes.number,
    label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
    ]),
    "aria-label": PropTypes.string,
    color: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.func
    ])
}

NumberField.defaultProps = {
    nullable: true
}

export default NumberField;